import { protectFeature } from '~libs.shared.system';

import { useAiAssistantConfigurationQuery } from './useAiAssistantConfigurationQuery';

export const useAiAssistantAvailable = (): boolean => {
   const aIAssistantAvailable = protectFeature(['aiExperimental', 'aiAssistant']);
   const { data: aiAssistantConfiguration } = useAiAssistantConfigurationQuery({ enabled: aIAssistantAvailable });

   return (
      aIAssistantAvailable &&
      Boolean(aiAssistantConfiguration?.effectiveEnabled) &&
      Boolean(aiAssistantConfiguration?.enabledByProvider)
   );
};
